import React, { useState, useCallback, useMemo, useRef } from 'react';
import './Trainers.css';

const Trainers = ({ trainersId = "trainers" }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const slideRef = useRef(null);

  const trainersData = useMemo(() => [
    {
      name: "Petr Vaněk",
      email: "vankefitness@email.cz",
      phone: "+420 774 56 20 11",
      image: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image28.webp",
      title: "Trenér roku 2009",
      subtitle: "Praxe přes 20 let",
      description: [
        "Trenér roku 2009 v časopisu Muscle fitness",
        "Komplexní osobní trenér fitness, kulturistiky a kondičního posilování s důrazem na individuální přístup",
        "Specialista na výživu včetně zaměření na ketogenní diety, výživu těhotných žen i pro klienty s kardiovaskulárními onemocněními",
        "Odborník na regeneraci, instruktor zdravotního cvičení, masér",
        "Tréninkový plán zaměřený na prevenci nemocí, sílu, zdraví a dlouhodobou rovnováhu těla"
      ]
    },
    {
      name: "Ing. Tadeáš Souček",
      email: "tadeas616@seznam.cz",
      phone: "+420 605 07 50 60",
      image: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image29.webp",
      title: "Certifikovaný trenér",
      subtitle: "11 let zkušeností",
      description: [
        "Cesta ke zdravému tělu a sebevědomí",
        "Věřím, že pohyb je klíčem ke zdraví, síle a sebevědomí",
        "Cvičení se věnuji 11 let, z toho posledních 6 let naplno",
        "Pomáhám klientům formovat postavu, zlepšovat kondici a objevovat radost z pohybu",
        "Specializace na budování svalové hmoty, redukci hmotnosti, výbušnost s prvky plyometrie a online coaching"
      ]
    },
    {
      name: "Karel Koldovský",
      email: "koldak1@gmail.com",
      phone: "+420 777 05 00 40",
      image: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image30.webp",
      title: "3x Mistr světa",
      subtitle: "Powerlifting expert",
      description: [
        "Instruktor fitness s praxí více než 15 let",
        "Trojnásobný mistr světa v benchpressu",
        "Řada svěřenců získala tituly z ME a MS v powerlifitingu",
        "Úspěšná silová příprava žen i mužů na fyzické testy do armády a k policii",
        "Specializace na sílu, výbušnost a sportovní výkon"
      ]
    },
    {
      name: "Alina Víšková",
      email: "alinavskv@seznam.cz",
      phone: "+420 725 55 54 89",
      image: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image27.webp",
      title: "Trenérka těla i mysli",
      subtitle: "Bikini Fitness závodnice",
      description: [
        "Certifikovaná osobní trenérka a výživová poradkyně",
        "Cvičení a zdravému životnímu stylu se věnuji více než polovinu svého života",
        "Mnohaleté závodní zkušenosti v kategorii Bikini Fitness",
        "Pomáhám ženám najít rovnováhu mezi tělem, myslí a duší",
        "Specializace na ženy, které chtějí zhubnout, zpevnit postavu, nabrat svaly a cítit se sebevědoměji",
        "Kombinuji profesionální přístup s empatickým a intuitivním vedením",
        "Věřím a vím, že cesta ke zdravému tělu začíná v hlavě a v srdci",
        "Možnost osobní i online individuální spolupráce"
      ]
    },
    {
      name: "Mgr. Jakub Debrecenyi",
      email: "jakub.debrecenyi@gmail.com",
      phone: "+420 731 050 748",
      image: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image32.webp",
      title: "Osobní trenér",
      subtitle: "Pohyb, který dává smysl",
      description: [
        "Absolvent Katedry studií lidského pohybu Ostravské univerzity se zaměřením na biomechaniku a pohyb člověka.",
        "Zakládám si na individuálním přístupu, kvalitě pohybu a propojení teoretických znalostí s praktickými zkušenostmi.",
        "Bývalý reprezentant ČR ve sportovním karate a medailista z mistrovství Evropy mládeže.",
        "Zkušenosti z náročného výcviku u výsadkového vojska.",
        "Specializace na rozvoj síly, kondice a zlepšení pohybových schopností, zdravý pohyb, prevenci přetížení a budování funkčního těla.",
        "Nabízím: zvýhodněnou cenu pro dvojice, online spolupráci, off-season přípravu sportovců, programming po zranění/úrazu a přípravu na výběrová řízení k bezpečnostním sborům."
      ]
    },
    {
      name: "Vladimír Vladimirov",
      email: "vl711@seznam.cz",
      phone: "+420 734 468 985",
      image: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image31.webp",
      title: "Osobní trenér",
      subtitle: "Trénink & výživa na míru",
      description: [
        "Individuální přístup pro začátečníky i pokročilé",
        "Vytvoření tréninkového plánu na míru i pro trénink bez trenéra",
        "Poradenství ohledně suplementace",
        "Výživové poradenství včetně vstupní konzultace, kde probereme stravovací návyky, potřeby klienta a dietní přístupy (redukční, sportovní, zdravotní)",
        "Možnost komplexních balíčků zahrnujících více služeb s individuálním přístupem"
      ]
    }
  ], []);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % trainersData.length);
  }, [trainersData.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + trainersData.length) % trainersData.length);
  }, [trainersData.length]);

  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  // Touch handlers pro swipe s lepší optimalizací pro iOS
  const handleTouchStart = useCallback((e) => {
    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = e.touches[0].clientX;
  }, []);

  const handleTouchMove = useCallback((e) => {
    touchEndX.current = e.touches[0].clientX;
  }, []);

  const handleTouchEnd = useCallback(() => {
    if (!touchStartX.current || !touchEndX.current) return;
    
    const distance = touchStartX.current - touchEndX.current;
    const minSwipeDistance = 50;

    if (Math.abs(distance) > minSwipeDistance) {
      if (distance > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }

    touchStartX.current = 0;
    touchEndX.current = 0;
  }, [nextSlide, prevSlide]);

  const currentTrainer = trainersData[currentSlide];

  return (
    <div id={trainersId} className="trainers-slideshow-section">
      <div className="trainers-slideshow-container">
        {/* Header */}
        <div className="trainers-slideshow-header">
          <h2 className="trainers-slideshow-title">
            Naši trenéři
          </h2>
          <p className="trainers-slideshow-description">
            Poznejte náš tým zkušených trenérů, kteří vám pomohou dosáhnout vašich{' '}
            <span className="trainers-highlight">fitness cílů.</span>
          </p>
        </div>

        {/* Slideshow */}
        <div className="trainers-slideshow">
          {/* Banner with trainer */}
          <div 
            ref={slideRef}
            className="trainer-banner"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {/* Background Image */}
            <div 
              className="trainer-banner-bg"
              style={{ backgroundImage: `url(${currentTrainer.image})` }}
            />
            <div className="trainer-banner-overlay"></div>

            {/* Content */}
            <div className="trainer-banner-content">
              {/* Left side - Info */}
              <div className="trainer-info-side" key={`info-${currentSlide}`}>
                <div className="trainer-badge">TRENÉR</div>
                <h3 className="trainer-name">{currentTrainer.name}</h3>
                <p className="trainer-title">{currentTrainer.title}</p>
                <p className="trainer-subtitle">{currentTrainer.subtitle}</p>

                <div className="trainer-description-list">
                  {currentTrainer.description.map((item, index) => (
                    <div key={index} className="trainer-description-item">
                      <span className="checkmark">✓</span>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>

                <div className="trainer-contact-buttons">
                  <a 
                    href={`mailto:${currentTrainer.email}`}
                    className="trainer-contact-btn trainer-email-btn"
                  >
                    <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    Email
                  </a>
                  <a 
                    href={`tel:${currentTrainer.phone}`}
                    className="trainer-contact-btn trainer-phone-btn"
                  >
                    <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    Zavolat
                  </a>
                </div>
              </div>

              {/* Right side - Image */}
              <div className="trainer-image-side" key={`image-${currentSlide}`}>
                <img 
                  src={currentTrainer.image} 
                  alt={currentTrainer.name}
                  className="trainer-main-image"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button 
            className="slideshow-nav-btn prev-btn"
            onClick={prevSlide}
            aria-label="Previous trainer"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button 
            className="slideshow-nav-btn next-btn"
            onClick={nextSlide}
            aria-label="Next trainer"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Dots Navigation */}
          <div className="slideshow-dots">
            {trainersData.map((_, index) => (
              <button
                key={index}
                className={`slideshow-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to trainer ${index + 1}`}
              />
            ))}
          </div>

          {/* Slide Counter */}
          <div className="slideshow-counter">
            {currentSlide + 1} / {trainersData.length}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trainers;